import { API } from 'aws-amplify'
import { useEffect, useState } from 'react'
import { useGlobalState } from '../../../store'
import { useLocalization } from '../../../localization'

// Removed Ant Design imports
import {ReactComponent as Connections} from '../../../images/svg/connections.svg'
import {ReactComponent as Info} from '../../../images/svg/info.svg'
import {
    sync_plans_new_monthly,
    sync_plans_new_yearly,
    v3_plans
} from '../components/OrgPrices'

// Added CBSelect, CBCheckbox, CBInput (already partially imported via cbd)
import { CBSelect } from '../../core/components/CBSelect';
import { CBCheckbox } from '../../core/components/CBCheckbox';
import {
    CBHeader,
    CBIncrementer,
    CBRadioGroupBig,
    SubmitButton,
    CBInput, // Ensure CBInput is here
    CBRadioGroup, // Ensure CBRadioGroup is here
    CBAlert // Added CBAlert
} from '../../core/components/cbd'
// Removed Panel destructuring

const theme = {
  scheme: 'google',
  author: 'seth wright (http://sethawright.com)',
  base00: '#1d1f21',
  base01: '#282a2e',
  base02: '#373b41',
  base03: '#969896',
  base04: '#b4b7b4',
  base05: '#c5c8c6',
  base06: '#e0e0e0',
  base07: '#ffffff',
  base08: '#CC342B',
  base09: '#F96A38',
  base0A: '#FBA922',
  base0B: '#198844',
  base0C: '#3971ED',
  base0D: '#3971ED',
  base0E: '#A36AC7',
  base0F: '#3971ED',
};


const CreateOrganizationPage = ({}) => {
  const { t } = useLocalization()
  function getUserSeatLabel(label) {
    // Use state variable isYearlyPlan directly
    return `${label}-${isYearlyPlan}`
  }
  function getSyncLabel() {
     // Use state variable isYearlyPlan directly
    return `one-way-sync-2022-${isYearlyPlan}`
  }
  const [license] = useGlobalState('license')
  const [currentSyncs] = useGlobalState('syncs')
  const [currentSchedulers] = useGlobalState('schedules')

  const [accounts] = useGlobalState('accounts')
  const [orgId, setOrgId] = useState(undefined)

  const [admin, setAdmin] = useState(0)
  const [basic, setBasic] = useState(0)
  const [premium, setPremium] = useState(0)
  const [pro, setPro] = useState(0) // Legacy Pro?
  const [proV3, setProV3] = useState(0) // Current Pro?

  const [syncs, setSyncs] = useState(0)
  const [isYearlyPlan, setIsYearlyPlan] = useState("monthly") // Default to monthly string
  const [error,setError] = useState(null)
  const [currentPlan, setCurrentPlan] = useState('')
  const [loading, setLoading] = useState(false)
  const [converted, setConverted] = useState(true)
  const [domains, setDomains] = useState([])

  const filterDomains = [
    'gmail.com', 'outlook.com', 'hotmail.com', 'fastmail.com', 'protonmail.com',
    'google.com', 'microsoft.com', 'yahoo.com', 'comcast.net', 'att.net',
    'verizon.net', 'me.com', 'icloud.com', 'googlemail.com'
  ];

  useEffect(() => {
    if (license.planId) {
      if (license.planId.includes('yearly')) {
        setIsYearlyPlan("yearly")
      } else {
        setIsYearlyPlan("monthly") // Ensure default is monthly string
      }
      // Determine current plan based on planId structure
      if (license.planId.includes('pro-v3')) {
          setCurrentPlan('pro-v3');
      } else if (license.planId.includes('pro')) { // Check for legacy pro
          setCurrentPlan('pro'); // Or map to 'premium' if legacy pro is treated as premium now
      } else if (license.planId.includes('premium')) {
          setCurrentPlan('premium');
      } else if (license.planId.includes('basic')) {
          setCurrentPlan('basic');
      } else if (license.planId.includes('admin')) {
          setCurrentPlan('admin');
      } else if (license.planId === 'calendarbridge-test') { // Handle legacy test plan
          setCurrentPlan('premium'); // Map legacy test to premium
      }
    }
  }, [license])

  useEffect(()=>{
    let domains = domainOptions()
    setDomains(domains)
    if(domains.length > 0) {
      setOrgId(domains[0].value)
    }
  },[accounts])


  async function adjustSeats(org) {
    setError(null)
    var body = {
      seats: {},
      userPlan: `${currentPlan}-${isYearlyPlan}`,
      converted: converted,
    }
    if (syncs > 0) body.seats[getSyncLabel()] = syncs

    if (admin > 0) body.seats[getUserSeatLabel('admin')] = admin
    if (basic > 0) body.seats[getUserSeatLabel('basic')] = basic
    if (premium > 0) body.seats[getUserSeatLabel('premium')] = premium
    if (pro > 0) body.seats[getUserSeatLabel('pro')] = pro // Legacy pro?
    if (proV3 > 0) body.seats[getUserSeatLabel('pro-v3')] = proV3 // Current pro?

    if (!converted) {
      body.seats[getUserSeatLabel('group-admin')] = 1
    } else {
      // Ensure currentPlan is valid before accessing seats
      if (currentPlan && body.seats[getUserSeatLabel(currentPlan)] !== undefined) {
         body.seats[getUserSeatLabel(currentPlan)] = (body.seats[getUserSeatLabel(currentPlan)] || 0) + 1;
      } else if (currentPlan) {
         // If the plan doesn't exist in seats yet, initialize it
         body.seats[getUserSeatLabel(currentPlan)] = 1;
      }
    }
    body.subscriptionId = license.stripeUserId

    try {
      setLoading(true)
      var orgResponse = await API.post( // Renamed variable to avoid conflict
        'organization',
        '/organization/?create_seats=true&id=' + orgId,
        { body }
      )
      console.log(orgResponse)
      if (orgResponse.message.includes('stripe.com')) window.location = orgResponse.message
      // Handle non-redirect success? Maybe reload or navigate?
      // else { window.location.reload(); } // Example
    } catch (e) {
      console.error("Error adjusting seats:", e);
      setError(e.response?.data?.message || e.message || 'Failed to update seats.');
    } finally {
       setLoading(false)
    }
  }

  function getPlanLabel(type) {
    // Safely access plan details
    const planDetails = v3_plans[type]?.[isYearlyPlan];
    if (!planDetails) return <div>Plan details not available</div>;

    return (
      <div className="text-sm space-y-1"> {/* Adjusted size and spacing */}
        <div>
          <b>${planDetails.value}</b> / month {isYearlyPlan === 'yearly' ? '(billed annually)' : ''}
        </div>
        <div>
          <b>{planDetails.syncs} Sync Connections</b>
        </div>
        {type !== "admin" && <div>Unlimited connected calendar accounts</div>}
        {type !== "admin" ? <div>10 booking links</div> : <div>0 booking links</div>}
        {type === "admin" && <div className="">Group administration only.</div>}
        {type === "admin" && currentSyncs?.length > 0 && <div className="text-red-500">Syncs will be deleted.</div>}
        {type === "admin" && currentSchedulers?.length > 0 && <div className="text-red-500">Schedulers will be deleted.</div>}
      </div>
    )
  }

  // Generate options for the domain select
  const domainOptions = () => {
      const domains = new Set();
      if (license.email && !filterDomains.includes(license.email.split('@')[1])) {
          domains.add(license.email.split('@')[1]);
      }
      accounts.forEach(acc => {
          if (acc.email && !filterDomains.includes(acc.email.split('@')[1])) {
              domains.add(acc.email.split('@')[1]);
          }
      });
      
      return Array.from(domains).map(domain => ({ label: domain, value: domain }));
  };


  return (
    <>
      {((license.email && license.orgId == 'single') ||
        (process.env.REACT_APP_DEBUG_UI && license.email)) && (
        // Replaced Layout with div
        <div className="cb-content-frame bg-white">
          {process.env.REACT_APP_DEBUG_UI && license.orgId != 'single' && (
            <div className="text-red-600 p-4">
              Debug: Already part of an organization.
            </div>
          )}
          <div className="m-8" style={{ minHeight: 800 }}>
            <CBHeader
              icon={<Connections />}
              label={t('organization.create_organization')}
              buttonLabel={t('common.help')}
              buttonIcon={<Info />}
              buttonAction={e=>{
                window.open(
                  'https://help.calendarbridge.com/doc/group-account-management/creating-a-group-account/',
                  '_blank'
                )
              }}
            />
            <p className="mb-4">{t('settings.organization_label')}</p> {/* Reusing settings key */}
            <div className="flex flex-row mb-4">
              {/* Replaced Select with CBSelect */}
              <CBSelect
                style={{ width: 300 }}
                placeholder={t('organization.create_org_select_domain_placeholder')}
                selectedValue={orgId}
                onChange={(v) => {
                  setOrgId(v.toLowerCase())}
                }
                labels={domains.map(opt => opt.label)}
                values={domains.map(opt => opt.value)}
              />
             </div>
             {filterDomains.includes(license.email?.split('@')[1]) && accounts.length === 0 && (
                 <div className="mt-4 mb-4 text-sm"> {/* Adjusted size */}
                    <a href="/dashboard/accounts/new" className="text-blue-600 hover:underline">{t('organization.create_org_add_business_account_link')}</a>
                 </div>
             )}

              
            <div className="flex items-center justify-center my-6"> {/* Added margin */}
              {/* Replaced Radio.Group with CBRadioGroup */}
              <CBRadioGroup
                title={t('organization.billing_period')}
                selected={["monthly","yearly"].indexOf(isYearlyPlan)}
                values={["monthly","yearly"]} // Pass value directly
                labels={[t('organization.monthly'),t('organization.yearly')]}
                buttonStyle={true} // Assuming CBRadioGroup supports button style via prop
                onChange={(val) => {
                  setIsYearlyPlan(["monthly","yearly"][val])
                }} // Use value
              />
            </div>
            {currentPlan != '' && (
              <CBRadioGroupBig
                id="plan-selection-org" // Unique ID
                title={t('organization.your_user_plan')}
                horizontal={true}
                collapsible={false}
                selected={
                  ['admin','basic', 'premium', 'pro-v3'].indexOf(currentPlan)
                }
                values={['admin','basic', 'premium', 'pro-v3']}
                labels={[t('organization.admin_only'), t('organization.basic'), t('organization.premium'), t('organization.pro')]}
                subLabels={[
                  getPlanLabel('admin'),
                  getPlanLabel('basic'),
                  getPlanLabel('premium'),
                  getPlanLabel('pro'), // Assuming 'pro' maps to 'pro-v3' details
                ]}
                onChange={(idx) => {
                  setCurrentPlan(['admin','basic', 'premium', 'pro-v3'][idx])}} // Use value
              />
            )}
            <div className="lg:w-2/3 mt-6"> {/* Added margin */}
              <div className="text-lg mb-2">{t('organization.organization_seats')}</div>

              {/* Simplified seat selection using map */}
              {['basic', 'premium', 'pro-v3', 'admin'].map(planType => {
                  const planDetails = v3_plans[planType]?.[isYearlyPlan];
                  if (!planDetails) return null; // Skip if plan details missing

                  let count, setCount;
                  if (planType === 'basic') { count = basic; setCount = setBasic; }
                  else if (planType === 'premium') { count = premium; setCount = setPremium; }
                  else if (planType === 'pro-v3') { count = proV3; setCount = setProV3; }
                  else if (planType === 'admin') { count = admin; setCount = setAdmin; }
                  else return null; // Should not happen

                  const labelMap = {
                      'basic': t('organization.basic_user_seat'),
                      'premium': t('organization.premium_user_seat'),
                      'pro-v3': t('organization.pro_user_seat'),
                      'admin': t('organization.admin_user_seat'),
                  };

                  return (
                      <div key={planType} className="grid grid-cols-1 md:grid-cols-2 items-center gap-x-8 p-4 m-2 bg-neutral rounded">
                        <div className="text-md md:text-lg mb-2 md:mb-0">{labelMap[planType]}</div>
                        <div className={'flex flex-col sm:flex-row gap-4 items-center'}>
                          <CBIncrementer
                            min={0}
                            onChange={setCount}
                            defaultValue={count}
                            max={planType === 'admin' ? 5 : undefined} // Max 5 for admin
                          />
                          <div className="font-bold text-sm"> {/* Adjusted size */}
                            x ${planDetails.value} / {isYearlyPlan === 'yearly' ? 'year' : 'month'}
                          </div>
                        </div>
                      </div>
                  );
              })}

              {/* Managed Syncs */}
              <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-x-8 p-4 m-2 bg-neutral rounded">
                <div className="text-md md:text-lg mb-2 md:mb-0">{t('organization.managed_sync')}</div>
                <div className={'flex flex-col sm:flex-row gap-4 items-center'}>
                  <CBIncrementer
                    min={0}
                    onChange={setSyncs}
                    defaultValue={syncs}
                  />
                  <div className="font-bold text-sm"> {/* Adjusted size */}
                    x ${isYearlyPlan === 'yearly' ? sync_plans_new_yearly : sync_plans_new_monthly} / {isYearlyPlan === 'yearly' ? 'year' : 'month'}
                  </div>
                </div>
              </div>

              {error && <CBAlert variant="error" message={error} className="m-4" />}

              <SubmitButton
                loading={loading}
                disabled={orgId === undefined || orgId === '' || loading} // Check orgId validity
                onClick={(e) => adjustSeats()}
                className="mt-6" // Added margin
              >
                {t('organization.create_organization_button')}
              </SubmitButton>

            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default CreateOrganizationPage;
// Removed helper function getOptions as it's part of the class now
